import React from "react";

function EmergencyContacts() {
    const emergencyContacts = [
        "Dr. K V RamaRao-9100662195",
        "Dr. K Sruthi-9100190291",
        "P Nagamani-9440926698",
        "J Sesha Naidu-9440663357",
        "M Pushpavathi-9502361362",
        "P Pushpa-9845810067",
        "P Praveen-8374188768",
    ];

    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <div className="caboutus">
                <b>
                    <p>Permanent Campus : 0877-250 3770</p>
                    <p>Temporary Campus : 0877-250 3771</p>
                    <p>
                        Ambulance drivers : Suresh - 9381225477 / Venkatesh -
                        9346617754
                    </p>
                </b>
            </div>
            <br />
            <div>
                <h3 className="mb-15">Medical Emergency Contacts</h3>
                <ul>
                    {emergencyContacts.map((item, index) => (
                        <li
                            key={index}
                            className="caboutus"
                            style={{ display: "flex", flexDirection: "row" }}
                        >
                            <i
                                className="icon fal fas fa-caret-right pl-5"
                                style={{
                                    display: "block",
                                    alignSelf: "flex-start",
                                    marginTop: "0.31lh",
                                }}
                            />
                            <p className="pl-10">{item}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default EmergencyContacts;
